// 2026-05-26 - FormuLearning - 전체 레이아웃 셸
// 2026-09-09 수정 - 이슈 #72(M901-05): 전역 알림 호스트(`ToastHost`) 장착. 프로젝트
//   로드 성공·취소 안내가 어느 화면에서든 뜨려면 셸이 들고 있어야 한다.
// 2026-09-23 수정 - 이슈 #82: 진행 중 작업(`busyStore`)이 있을 때도 창 종료·새로고침 전에 경고한다 — 결과 유실은 감수하되 실수만 막는다.
// 파일 위치: frontend/src/components/layout/AppShell.tsx

import { useEffect } from 'react'
import Header from './Header'
import LeftPanel from './LeftPanel'
import ScrollStepper from './ScrollStepper'
import ToastHost from '../feedback/Toast'
import { useProjectStore } from '../../stores/projectStore'
import { useSaveBuffer } from '../../stores/saveBufferStore'
import { useBusyStore } from '../../stores/busyStore'

export default function AppShell({ children }: { children: React.ReactNode }) {
  const currentProject = useProjectStore((s) => s.currentProject)

  // 2026-07-09 - 이슈 #33 4단계: Autosave OFF 미저장 상태에서 창 종료·새로고침 시 경고.
  useEffect(() => {
    const handler = (e: BeforeUnloadEvent) => {
      if (useSaveBuffer.getState().hasDirty() || useBusyStore.getState().task) {
        e.preventDefault()
        e.returnValue = ''
      }
    }
    window.addEventListener('beforeunload', handler)
    return () => window.removeEventListener('beforeunload', handler)
  }, [])

  return (
    <div className="flex h-screen overflow-hidden bg-bg-base">
      <LeftPanel />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main id="step-scroll-container" className="flex-1 overflow-y-auto px-5 py-5">
          {children}
        </main>
      </div>
      {currentProject && <ScrollStepper />}
      <ToastHost />
    </div>
  )
}
